import { BoostHistory } from "../../../types/models/boosts/boosts.types";

export const getStatKeyLabel = (key: BoostHistory['stats_key']) => {
  switch (key) {
    case "id_commercial":
      return 'Commercial'
    case "won_prospects_total":
      return 'Gagnés'
    case "lost_prospects_total":
      return 'Perdus'
    case "to_be_remind_prospects_total":
      return 'À rappeler'
    case "prospects_total":
      return 'Prospectés'
    case "win_prospects_ratio":
      return 'Ratio'
    case "win_prospects_average":
      return 'Moyenne'
    case "sales_revenue":
      return 'C.A'
    case "commissions_sum":
      return 'Commissions'
  }
}